import React from "react";

import InputCheckbox from "../../Inputs/Checkbox";
import { ScrollableColumn } from "../TableLiteScrollable/TableLiteScrollable";
import css from "./TableLiteBulk.module.scss";

export const addCheckboxToColumns = (
	columns: ScrollableColumn[],
	onCheckboxChange: (row, isSelected) => void | Promise<void>,
	isRowChecked: (row) => boolean,
	disabled: boolean,
	hidden: boolean,
	animated: boolean
): ScrollableColumn[] => {
	const firstColumn = columns[0];
	const firstColumnGetter = firstColumn.getter;
	let newFirstColumn;
	if (firstColumnGetter) {
		newFirstColumn = {
			...firstColumn,
			getter: (row) => {
				const isSelected = isRowChecked(row);
				return (
					<div className={` ${css.checkboxColumn} `}>
						<InputCheckbox
							value={isSelected}
							onChange={() => onCheckboxChange(row, isSelected)}
							disabled={disabled}
						/>
						<div
							className={` ${css.columnContent} ${animated ? css.isAnimated : ""} ${hidden ? css.hidden : css.showing} `}
						>
							{firstColumnGetter(row)}
						</div>
					</div>
				);
			},
		};
	}
	return [newFirstColumn, ...columns.slice(1)];
};
